<template >
  <div :key="forKey">
    <div v-if="!cookiesObject.token">
      <p class="someText" style="text-align: center; padding: 5px">
        {{ $t("LanguageEn.myTeamsText1") }}
        <img
          src="@/assets/favorite1.png"
          style="width: 14px; margin-top: -4px"
          alt=""
        />
        {{ $t("LanguageEn.myTeamsText2") }}
      </p>
    </div>
    <div style="background: #212226; padding-bottom: 1px" v-else>
      <div v-if="favs.length != 0">
        <div
          style="padding-top: 0px; padding-left: 8px"
          v-for="fav in favs"
          :key="fav.id"
        >
          <p
            class="someText MobileHide simg"
            style="
              margin-top: 0px;
              margin-bottom: 0px;
              height: 40px;
              padding-top: 10px;
            "
          >
            <img
              :src="defLogo + fav.id"
              style="
                width: 21px;
                margin-bottom: 5px;
                margin-right: 5px;
                margin-left: 10px;
              "
              alt=""
            />
            <router-link
              style="color: white"
              id="router-link"
              :to="{
                name: 'teamPagePar',
                params: { id: fav.id, name: fav.name },
              }"
            >
              <span
                v-b-tooltip.hover
                :title="fav.name"
                v-if="ssize > 768 && ssize <= 992"
              >
                {{ fav.name.slice(0, 3) | transliterate(cookiesObject.lang) }}.
              </span>
              <span v-if="ssize > 992 && ssize <= 1200">
                <span v-if="fav.name.length < 13"
                  >{{ fav.name | transliterate(cookiesObject.lang) }}
                </span>
                <span v-b-tooltip.hover :title="fav.name" v-else
                  >{{
                    fav.name.slice(0, 10) | transliterate(cookiesObject.lang)
                  }}..</span
                >
              </span>
              <span v-else-if="ssize <= 768"></span>
              <span v-if="ssize > 1200">
                <span v-if="fav.name.length < 15"
                  >{{ fav.name | transliterate(cookiesObject.lang) }}
                </span>
                <span v-b-tooltip.hover :title="fav.name" v-else
                  >{{
                    fav.name.slice(0, 14) | transliterate(cookiesObject.lang)
                  }}..</span
                >
              </span>
            </router-link>
            <b-btn
              v-if="ssize > 772"
              v-on:click="(ids = fav.id), $refs['remove-modal4'].show()"
              style="
                float: right;
                background: none;
                border: none;
                margin-top: -7px;
              "
            >
              <img
                class="imag"
                src="@/assets/delete.png"
                style="width: 10px; margin-top: 6px"
                alt=""
              />
            </b-btn>
          </p>
          <p
            class="someText MobileShow"
            style="
              text-align: left;
              height: 25px;
              margin-left: 10px;
              padding-top: 10px;
            "
          >
            <img
              :src="defLogo + fav.id"
              style="width: 21px; margin-bottom: 5px; margin-right: 5px"
              alt=""
            />
            <router-link
              style="color: white"
              id="router-link"
              :to="{
                name: 'teamPagePar',
                params: { id: fav.id, name: fav.name },
              }"
            >
              <span v-if="fav.name.length > 24"
                >{{ fav.name.slice(0, 24) }}..</span
              >
              <span v-else>{{ fav.name }}</span>
            </router-link>
            <b-btn
              v-on:click="(ids = fav.id), $refs['remove-modal4'].show()"
              style="
                float: right;
                background: none;
                border: none;
                margin-top: -7px;
              "
            >
              <img
                src="@/assets/delete.png"
                style="width: 10px; margin-bottom: 10px"
                alt=""
              />
            </b-btn>
          </p>
        </div>
        <div style="padding-top: 0px">
          <p
            v-b-modal.modal-search
            class="someText MobileHide"
            style="
              margin-top: 0px;
              margin-bottom: 0px;
              height: 40px;
              padding-top: 10px;
              color: #3d8f41;
              padding-left: 10px;
              cursor: pointer;
              border-top: 1px solid #2c2d31;
            "
          >
            {{ $t("LanguageEn.addMore") }}
            <img
              src="@/assets/arright.png"
              style="
                width: 14px;
                margin-top: 5px;
                margin-right: 10px;
                float: right;
              "
              alt=""
            />
          </p>
        </div>
      </div>
      <div v-else>
        <p class="someText" style="text-align: center; padding: 5px">
          {{ $t("LanguageEn.myTeamsText1") }}
          <img
            src="@/assets/favorite1.png"
            style="width: 14px; margin-top: -4px"
            alt=""
          />
          {{ $t("LanguageEn.myTeamsText2") }}
        </p>
      </div>
    </div>
    <b-modal
      ref="remove-modal4"
      header-class="sureModal4"
      body-class="sureModal4"
      size="md"
      hide-footer
      centered
      title="Zunisport"
    >
      <p style="text-align: center; font-size: 12px; color: #a3a3a3">
        {{ $t("LanguageEn.removeTeam") }}
      </p>
      <b-row>
        <b-col style="text-align: center">
          <b-button
            type="submit"
            class=""
            style="
              background: #bb4250;
              border: none;
              border-radius: 2px;
              width: 180px;
            "
            @click="
              removeFavorite({ value: ids, type: team }),
                $refs['remove-modal4'].hide()
            "
            >{{ $t("LanguageEn.remove") }}</b-button
          >
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "HeaderBody",
  data() {
    return {
      cookiesObject: "",
      defLogo: "https://sportapi.zuniac.com/team/logo/",
      forKey: "",
      team: "team",
      ssize: "",
      ids: "",
    };
  },

  mounted() {
    var cookiesObject = document.cookie
      .split(";")
      .map((cookie) => cookie.split("="))
      .reduce(
        (accumulator, [key, value]) => ({
          ...accumulator,
          [key.trim()]: decodeURIComponent(value),
        }),
        {}
      );
    this.cookiesObject = cookiesObject;

    if (this.cookiesObject.token) {
      this.getArray();
    }

    window.addEventListener("resize", this.nowSize);
    this.nowSize();
  },

  destroyed() {
    window.removeEventListener("resize", this.nowSize);
  },

  methods: {
    ...mapActions(["getArray", "removeFavorite"]),
    nowSize() {
      this.ssize = window.innerWidth;
    },
  },

  props: {},
  computed: {
    ...mapGetters(["favs"]),
  },

  watch: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.someText {
  color: white;
  font-size: small;
  background: #212226;
}
.someText:hover {
  background: #28292c;
}
.simg .imag {
  display: none;
}
.simg:hover .imag {
  display: block;
}

@media only screen and (max-width: 770px) {
  .MobileHide {
    display: none;
  }
}

@media only screen and (min-width: 770px) {
  .MobileShow {
    display: none;
  }
}
</style>
<style>
.sureModal4 {
  background: #212225;
  color: lightgrey;
  border: none;
  font-size: 12px !important;
}
.sureModal4 .modal-title {
  font-size: 15px !important;
}
.sureModal4 .close {
  color: white !important;
}
</style>
